import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { toast } from "react-toastify";
import { AiFillMessage } from "react-icons/ai";
import { IoMdCall } from "react-icons/io";
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";

const SingleEntry = ({
  SingleEntryLoading,
  postSingleEntry,
  setOpenUploadModel,
  groupId,
}) => {
  const InitialValues = {
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    groupId,
  };

  const SubmitHandler = (values) => {
    if (values.mobile.length != 9) {
      return toast.error("Please enter a valid 9 digit mobile number");
    }
    postSingleEntry(values);
  };

  return (
    <Model width={`w-11/12 max-w-2xl `} setOpenModel={setOpenUploadModel}>
      <Title>Choose Campaign type</Title>

      <Wrapper>
        <Link to="/cms/sms/add" className="w-full">
          <SMS />
        </Link>
        <Voice />
        <Email />
      </Wrapper>
    </Model>
  );
};

const SMS = () => (
  <Box className="bg-orange-500 hover:bg-orange-600 ">
    <AiFillMessage className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
    <BoxText>SMS</BoxText>
  </Box>
);
const Voice = () => (
  <Box className="bg-cyan-600 hover:bg-cyan-700 ">
    <IoMdCall className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
    <BoxText>Voice</BoxText>
  </Box>
);
const Email = () => (
  <Box className="bg-rose-500 hover:bg-rose-600">
    <MdEmail className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
    <BoxText>Email</BoxText>
  </Box>
);

const Wrapper = tw.div`
 mt-10 mb-6 px-1 flex flex-col sm:flex-row justify-between space-y-5  sm:space-y-0 sm:space-x-6 md:space-x-10`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

const Box = tw.div`flex sm:flex-col items-center space-x-2 sm:space-x-0 sm:space-y-1   rounded-md  py-4  sm:py-5 w-full justify-center  cursor-pointer`;
const BoxText = tw.p`text-base font-medium text-white`;

export default SingleEntry;
